import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { MyApp } from './app.component';
import { TitlePage } from '../pages/title/title';
import { RoomPage } from '../pages/room/room';
import { WaitPage } from '../pages/wait/wait';
import { SnapPage } from '../pages/snap/snap';
import { JudgePage } from '../pages/judge/judge';
import { ScorePage } from '../pages/score/score';
import { FinalPage } from '../pages/final/final';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { SocketProvider } from '../providers/socket/socket';
import { SceneProvider } from '../providers/scene/scene';
import { HttpClientModule } from '@angular/common/http'; 

@NgModule({
  declarations: [
    MyApp,
    TitlePage,
    RoomPage,
    WaitPage,
    SnapPage,
    JudgePage,
    ScorePage,
    FinalPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    TitlePage,
    RoomPage,
    WaitPage,
    SnapPage,
    JudgePage,
    ScorePage,
    FinalPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    SocketProvider,
    SceneProvider,
  ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts